import React from "react";
import UpdateChequeStatusPreCheckModal from "../deposites/components/UpdateChequeStatusPreCheckModal";
import { getListByChequeNumberApi } from "../receipts/api";

export const chequeTips = [
  "Upload cheque receipts within 4 days for seamless experience.",
  "Upload cheque receipts within 4 days for seamless experience.",
  "Upload cheque receipts within 4 days for seamless experience.",
];

export const depositedListFilter = [
  { label: "Not deposited", value: "NOT_DEPOSITED" },
  { label: "Deposited", value: "DEPOSITED" },
  { label: "All", value: "all" },
];

export const dashBoardFilterBtnStyle = {
  height: "32px",
  color: "black",
};




export const handleChequeStatusUpdateWithPreCheck = async ({
  rowData,
  openFinalModal,
  openModal,
  title,
  hideModal,
  actionType,
}) => {
  const response = await getListByChequeNumberApi({
    referenceNumber: rowData.referenceNumber,
    psid: rowData.psid,
  });
  const rows = response?.data?.paginatedData || [];
  if (rows.length === 1 || rows.length === 0) {
    openFinalModal();
    return;
  }

  openModal({
    title: title,
    content: (
      <UpdateChequeStatusPreCheckModal
        receipts={rows}
        actionType={actionType}
        onProceed={() => {
          hideModal();
          openFinalModal();
        }}
        onClose={hideModal}
      />
    ),
    maxWidth: "md",
  });
};
